const ENV = APP_ENV || 'qa'; // eslint-disable-line no-undef
const isProd = ENV === 'prod';

import { getLocationHost } from 'utils/browser';
import { Auth } from '@biw/bridge';

// eslint-disable-next-line no-undef
export const getCompanyCodeFromUrl = host => host.split( '.' )[ 0 ];

const envPrefix = isProd ? '' : `${ENV}.`;
const KONG_URL = `https://${envPrefix}api.biw.cloud`;

const CONFIG = {
    ENV,
    // eslint-disable-next-line no-undef
    COMPANY_CODE: COMPANY_CODE || getCompanyCodeFromUrl( getLocationHost() ),
    // eslint-disable-next-line no-undef
    API_URL: API_URL || `${KONG_URL}/salesmaker`,
    PROVIDER_URL: `${KONG_URL}/v1/id`
};

export const auth = new Auth( {
    authority: CONFIG.PROVIDER_URL,
    clientId: CONFIG.COMPANY_CODE
} );

export default CONFIG;
